
<div class="calendar-container">
    <div class="row text-center mt-3">
    <div class="col-12">
        {{months[month-1]}} {{year}}
    </div>
        <div class="col"></div>
        <div class="col" v-for="(label,index) in daysLabels" :key="`label${index}`">
            {{label}}
        </div>
        <div class="col"></div>
    </div>
    <div class="row text-center mt-3">
        <div class="col"><span v-if="checkWeekStart()" @click="previousWeek" class="change-date"><</span></div>
        <div class="col" v-for="(day,index) in days" :key="`day${index}`">
            <span class="dayContainer p-1" @click="changeDay(day)" :class="`${checkDay(day) ? 'active' : ''} ${isAvailable(day) ? 'available' : 'disabled'}`">{{formatDate(day)}}</span>
        </div>
        <div class="col"><span @click="nextWeek" class="change-date">></span></div>
    </div>
</div>
